import create from 'zustand'

type State = {
  identifierId: string
  setIdentifierId(identifierId: string)
  identifierPassword: string
  setIdentifierPassword(identifierPassword: string)
  setIdentifer(identifier: {
    identifierId?: string
    identifierPassword?: string
  })
}

const useIdentifierStore = create<State>((set) => {
  return {
    identifierId: '',
    setIdentifierId: (identifierId) => set({ identifierId }),
    identifierPassword: '',
    setIdentifierPassword: (identifierPassword) => set({ identifierPassword }),
    setIdentifer: ({ identifierId, identifierPassword }) =>
      set({ identifierId, identifierPassword }),
  }
})

export default useIdentifierStore
